module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-arrow-down-fill-00370972.svg";